import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import LovCoAFrom from "./LovCoAFrom";

const CoAForm = ({ mode, user, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    chart_account_code: "",    
    group_account_table: "",
    table_code: "",
    group_account_div: "",
    div_code: "",
    group_account_dep: "",
    dep_code:"",
    group_account_code:"",
    int_code: "",
    group_account_desc: "",
    chart_account_basic: "",
    chart_account_desc: "",
    entry_by: user?.name,
    reg_desc: user?.company,
  });
  const [masterCoA, setMasterCoA] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (formData.group_account_table) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API}/show-lov-account`,
            {
              group_account_table: formData.group_account_table,
              reg_desc: user?.company,
            }
          );
          setMasterCoA(response.data.data);
          setFormData((prev) => ({
            ...prev,
            chart_account_code: "",
            table_code: "",
            group_account_div: "",
            div_code: "",
            group_account_dep: "",
            dep_code: "",
            group_account_code: "",
            int_code: "",
            group_account_desc: "",
            chart_account_basic: "",
            chart_account_desc: "",
          }));
        } catch (error) {
          showError("Gagal mengambil data");
        }
      } else {
        setMasterCoA([]);
      }
    };

    fetchData();
  }, [formData.group_account_table, user?.company]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = { ...formData };

    try {
      const response = await axios({
        method: mode === "add" ? "POST" : "PUT",
        url:
          mode === "add"
            ? `${process.env.REACT_APP_API}/insert-coa`
            : '',
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
        },
      });

      showSuccess(mode === "add" ? "CoA berhasil ditambahkan" : "CoA berhasil diperbarui");
      const data= response.data.data[0].chart_account_code;
      setFormData({
        ...formData,
        chart_account_code: data
      });

    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          showError(error.response.data.message || "Data sudah ada");
          setFormData({
            ...formData,
            chart_account_code: "",    
            group_account_table: "",
            table_code: "",
            group_account_div: "",
            div_code: "",
            group_account_dep: "",
            dep_code:"",
            group_account_code:"",
            int_code: "",
            group_account_desc: "",
            chart_account_basic: "",
            chart_account_desc: "",
          });

        } else {
          showError(error.response.data.message || "Terjadi kesalahan");
        }
      } else {
        showError("Terjadi kesalahan koneksi ke server.");
      }
    }
  };

  const handleSelectData = (data) => {
    setFormData({
      ...formData,
      group_account_div: data.group_account_div,
      div_code: data.div_code,
      group_account_dep: data.group_account_dep,
      dep_code: data.dep_code,
      group_account_code: data.group_account_code,
      int_code: data.int_code,
      group_account_desc: data.group_account_desc,
      table_code: data.table_code,
      chart_account_basic: data.chart_account_code,
      chart_account_desc: data.chart_account_desc,
    });
    setShowModal(false);
  };

  return (        
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah CoA" : "Edit CoA"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Chart Account Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="chart_account_code"
                  className="form-control"
                  value={formData.chart_account_code}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Table</label>
              <div className="col-sm-8 d-flex align-items-center">
                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="group_account_table"
                    id="neraca"
                    value="NERACA"
                    checked={formData.group_account_table === "NERACA"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="neraca">
                    NERACA
                  </label>
                </div>
                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="group_account_table"
                    id="labarugi"
                    value="LABA RUGI"
                    checked={formData.group_account_table === "LABA RUGI"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="labarugi">
                    LABA RUGI
                  </label>
                </div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(true)}
                  disabled={masterCoA.length === 0}
                  title="Tampilkan Data"
                >
                  <i className="fa fa-eye"></i>
                </button>
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Div</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_div"
                  className="form-control"
                  value={formData.group_account_div}
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Div Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="div_code"
                  className="form-control"
                  value={formData.div_code}
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Dep</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_dep"
                  className="form-control"
                  value={formData.group_account_dep}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Dep Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="dep_code"
                  className="form-control"
                  value={formData.dep_code}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Desc</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_desc"
                  className="form-control"
                  value={formData.group_account_desc}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_code"
                  className="form-control"
                  value={formData.group_account_code}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">INT Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="int_code"
                  className="form-control"
                  value={formData.int_code}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Chart Account Basic</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="chart_account_basic"
                  className="form-control"
                  value={formData.chart_account_basic}
                  onChange={handleChange}
                  readOnly
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Chart Account Desc </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="chart_account_desc"
                  className="form-control"
                  value={formData.chart_account_desc}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="text-end">
              <button type="submit" className="btn btn-primary">
                {mode === "add" ? "Save" : "Update"}
              </button>
            </div>
          </form>

        </div>
      </div>
      {showModal && (
        <LovCoAFrom
          show={showModal}
          data={masterCoA}
          onClose={() => setShowModal(false)}
          onSelect={handleSelectData}
        />
      )}
    </div>
  );
};

export default CoAForm;
